import React, { useState } from 'react';
import { array, object, string } from 'yup';
import { Formik, Field, Form } from 'formik';
import { TextInput, InfoScreenInput } from 'components/FormComponents';
import { urlMessage } from 'utils/validationSchema';
import { FaRegPlusSquare, FaRegTrashAlt } from 'react-icons/fa';

const validationSchema = object().shape({
  label: string().required('El enunciado de la pregunta (es) es requerido'),
  en: string().required('El enunciado de la pregunta (en) es requerido'),
  gif: array().of(string().url(urlMessage)).ensure(),
});

const SelectImageForm = (props) => {
  const { onUpdateField, data, footer } = { ...props };
  const initialGifs = data && data.gif ? data.gif : [''];
  const [gifInputs, setGifInputs] = useState(initialGifs.length);

  return (
    <Formik
      initialValues={data}
      onSubmit={(values) => onUpdateField(values)}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {({ values, setFieldValue }) => (
        <Form className="form">
          <Field type="text" label="Enunciado de la pregunta (es)" name="label" component={TextInput} />
          <Field type="text" label="Enunciado de la pregunta (en)" name="en" component={TextInput} />
          <Field
              name="required"
              render={({ field }) => (
                <div className="form__input-container assessment__checkbox__input">
                  <input
                    {...field}
                    type="checkbox"
                    checked={field.value}
                    onChange={() => {
                      setFieldValue('required', !field.value);
                    }}
                  />
                  <label className="form__label">Obligatorio</label>
                </div>
              )}
            />
            <Field
              name="multi"
              render={({ field }) => (
                <div className="form__input-container assessment__checkbox__input">
                  <input
                    {...field}
                    type="checkbox"
                    checked={field.value}
                    onChange={() => {
                      setFieldValue('multi', !field.value);
                    }}
                  />
                  <label className="form__label">Múltiples respuestas</label>
                </div>
              )}
            />
            <Field
              name="chart"
              render={({ field }) => (
                <div className="form__input-container assessment__checkbox__input">
                  <input
                    {...field}
                    type="checkbox"
                    checked={field.value}
                    onChange={() => {
                      setFieldValue('chart', !field.value);
                    }}
                  />
                  <label className="form__label">Incluir gráfica</label>
                </div>
              )}
            />
          <hr />
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '20px' }}>
            <p>Agregar una imagen</p>
            <FaRegPlusSquare
              style={{ fontSize: '24px', cursor: 'pointer' }}
              onClick={() => {
                setGifInputs(prev => prev + 1);
                setFieldValue('gif', [...(values.gif || []), '']);
              }}
            />
          </div>
          {(values.gif || []).map((_, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                width: '100%',
                marginBottom: '10px',
              }}
            >
              <div style={{ flex: 1 }}>
                <Field
                  type="text"
                  label={`Image url ${index + 1}`}
                  name={`gif.${index}`}
                  component={InfoScreenInput}
                />
              </div>
              <div style={{ paddingTop: '34px', cursor: 'pointer' }}>
                <FaRegTrashAlt
                  onClick={() => {
                    if (gifInputs > 1) {
                      setGifInputs(prev => prev - 1);
                      const newGifs = [...values.gif];
                      newGifs.splice(index, 1);
                      setFieldValue('gif', newGifs);
                    }
                  }}
                  color="#dc3545"
                />
              </div>
            </div>
          ))}
          {footer}
        </Form>
      )}
    </Formik>
  );
};

export default SelectImageForm;
